import React from 'react';

import MainContentinnerHtml from 'components/MainContentInnerHtml';
import removeEmptyPTags from 'modules/News/utils/removeEmptyPtags';

import { INewsItemModel } from '@common/models/News/NewsItem';

interface PropsType {
	newsItem: INewsItemModel;
}

function NewsItemPageSection({ newsItem }: PropsType) {
	const clearDescription = removeEmptyPTags(newsItem.description ?? '');

	return <MainContentinnerHtml text={clearDescription} sx={{ flex: 1 }} />;
}

export default NewsItemPageSection;
